import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWifi = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 -2 20 20",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Page-1",
		stroke: "none",
		strokeWidth: 1,
		fill: "currentColor",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Dribbble-Light-Preview",
			transform: "translate(-60.000000, -3681.000000)",
			fill: "currentColor",
			children: /* @__PURE__ */ _jsx("g", {
				id: "icons",
				transform: "translate(56.000000, 160.000000)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M11.9795939,3535.00003 C11.9795939,3536.00002 12.8837256,3537 14,3537 C15.1162744,3537 16.0204061,3536.00002 16.0204061,3535.00003 C16.0204061,3532.00008 11.9795939,3532.00008 11.9795939,3535.00003 M9.71370846,3530.7571 L11.1431458,3532.17208 C12.7180523,3530.6121 15.2819477,3530.6121 16.8568542,3532.17208 L18.2862915,3530.7571 C15.9183756,3528.41413 12.0816244,3528.41413 9.71370846,3530.7571 M4,3525.10019 L5.42842711,3526.51516 C10.1551672,3521.83624 17.8448328,3521.83624 22.5715729,3526.51516 L24,3525.10019 C18.4772199,3519.63327 9.52278008,3519.63327 4,3525.10019 M21.1431458,3527.92914 L19.7147187,3529.34312 C16.5638953,3526.22417 11.4361047,3526.22417 8.28528134,3529.34312 L6.85685423,3527.92914 C10.8016971,3524.0242 17.1983029,3524.0242 21.1431458,3527.92914",
					id: "wifi-[#1018]"
				})
			})
		})
	})
});
export { SvgWifi as ReactComponent };
